import React from 'react';
import {Helmet} from 'react-helmet-async';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import {useServerDetails} from 'features/server/model/useServerDetails';
import {ServerBackgroundKind} from 'features/server/lib/serverView';
import Box from 'shared/ui/Box/Box';
import LoaderCentered from 'shared/ui/LoaderCentered/LoaderCentered';

import ServerHeader from './ServerHeader/ServerHeader';
import ServerStatistics from './ServerStatistics/ServerStatistics';
import ServerAlertRules from './ServerAlertRules/ServerAlertRules';
import ServerIncidentsSummary from './ServerIncidentsSummary/ServerIncidentsSummary';
import ServerMetrics from './ServerMetrics/ServerMetrics';

import styles from './ServerDetails.module.scss';

const BACKGROUND_CLASS: Record<NonNullable<ServerBackgroundKind>, string> = {
    en: 'enContainer',
    ok: 'okBackground',
    problem: 'problemBackground',
    paused: 'pausedBackground',
};

const ServerDetails: React.FC = () => {
    const {server, isLoading, isMobile, backgroundKind} = useServerDetails();

    if (isLoading || !server) {
        return <LoaderCentered active/>;
    }

    return (
        <>
            {
                isMobile &&
                <div className={styles.containerHeader}>
                    <ServerHeader server={server}/>
                </div>
            }

            <Box className={cn(styles.container, backgroundKind && styles[BACKGROUND_CLASS[backgroundKind]])}>
                <Helmet>
                    <title>{`${server.name} | ${t`Overseer`}`}</title>
                </Helmet>

                {
                    !isMobile &&
                    <>
                        <ServerHeader server={server}/>
                        <span className={styles.line}/>
                    </>
                }
                <ServerStatistics server={server}/>
                <span className={styles.line}/>
                <ServerAlertRules server={server}/>
            </Box>

            <ServerIncidentsSummary server={server}/>

            <ServerMetrics server={server}/>
        </>
    );
};

export default ServerDetails;
